<template>
    <div class="modal modal-form fade in show" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-inner">
                    <h5 class="title">Act planner</h5>
                    <div class="form">
                        <ValidationObserver ref="form">
                            <div class="row">
                                <ValidationProvider
                                    class="col-12"
                                    name="Type"
                                    v-slot="{ errors }"
                                    rules="required"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">Type*</label>
                                        <select
                                            class="custom-select pl-3"
                                            v-model="eventInfo.type"
                                        >
                                            <option
                                                v-for="(option, index) in eventsType"
                                                :key="index"
                                                :value="option"
                                            > {{ option }}</option>
                                        </select>
                                        <FormError :error="errors[0]" name="Type"/>

                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="From"
                                    v-slot="{ errors }"
                                    rules="required"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">From*</label>
                                        <section>
                                            <date-picker
                                                input-class="form-control pl-3"
                                                :disabled-date="checkDisabledDates"
                                                value-type="YYYY-MM-DD"
                                                format="MM-DD-YYYY"
                                                v-model="eventInfo.from"
                                            ></date-picker>
                                        </section>
                                        <FormError :error="errors[0]" name="From"/>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="To"
                                    v-slot="{ errors }"
                                    rules="required"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">To*</label>
                                        <date-picker
                                            input-class="form-control pl-3"
                                            :disabled-date="checkDisabledDates"
                                            value-type="YYYY-MM-DD"
                                            format="MM-DD-YYYY"
                                            v-model="eventInfo.to"
                                        ></date-picker>
                                        <FormError :error="errors[0]" name="To"/>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Start Location"
                                    v-slot="{ errors }"
                                    rules="required|min:3"

                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">Start Location*</label>
                                        <input
                                            type="text"
                                            class="form-control pl-3"
                                            v-model="eventInfo.start_location"
                                        >
                                        <FormError :error="errors[0]" name="Start Location"/>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="End Location"
                                    v-slot="{ errors }"
                                    rules="required|min:3"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">End Location*</label>
                                        <input
                                            type="text"
                                            class="form-control pl-3"
                                            v-model="eventInfo.end_location"
                                        >
                                        <FormError :error="errors[0]" name="End Location"/>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-12"
                                    name="Venue Name"
                                    v-slot="{ errors }"
                                    :rules="{ required :createdByAdmin }"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">Venue Name*</label>
                                        <select
                                            class="custom-select pl-3"
                                            v-model="eventInfo.company_id"
                                        >
                                            <option
                                                v-for="company in companies"
                                                :key="company.id"
                                                :value="company.id"
                                            > {{ company.name }}
                                            </option>
                                        </select>
                                        <FormError :error="errors[0]" name="Venue Name"/>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Price"
                                    v-slot="{ errors }"
                                    rules="required"
                                    v-if="createdByAdmin"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">Price*</label>
                                        <input
                                            type="text"
                                            class="form-control pl-3"
                                            v-model="eventInfo.price"
                                        >
                                        <FormError :error="errors[0]" name="Price"/>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Period"
                                    v-slot="{ errors }"
                                    rules="required"
                                    v-if="createdByAdmin"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">Period*</label>
                                        <input
                                            type="text"
                                            class="form-control pl-3"
                                            v-model="eventInfo.period"
                                        >
                                        <FormError :error="errors[0]" name="Period"/>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-12"
                                    name="Source"
                                    v-slot="{ errors }"
                                    rules="required"
                                    v-if="createdByAdmin"
                                >
                                    <div class="form-group mb-4">
                                        <label for="" class="form-label">Source*</label>
                                        <select class="custom-select pl-3" v-model="eventInfo.source">
                                            <option :value="`FCE Booking`">FCE Booking</option>
                                            <option :value="`Other bookings`">Other bookings</option>
                                        </select>
                                        <FormError :error="errors[0]" name="Source"/>
                                    </div>
                                </ValidationProvider>
                                <div class="col-md-4">
                                    <div class="form-group m-0">
                                        <button
                                            class="btn btn_primary-outline pl-5 pr-5"
                                            @click="closeModal"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-4" v-show="permissionForUpdate">
                                    <div class="form-group text-right m-0">
                                        <button
                                            @click="deleteEvent(eventInfo.id)"
                                            class="btn btn_delete"
                                        >DELETE</button>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="permissionForUpdate">
                                    <div class="form-group text-right m-0">
                                        <button
                                            type="submit"
                                            class="btn btn_golden"
                                            @click="validate"
                                        >
                                            <span class="pl-5 pr-5">Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import FormError from "./FormError.vue";
import EventsService from "../../services/EventsService"
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    name: 'EventModal',
    components: {FormError, DatePicker},
    emits: ['update-events'],
    props: {
        modalId: String,
        createdByAdmin: Boolean,
        artistId: Number,
        isUpdate: Boolean,
        eventsType: Array,
        existingEvent: Object,
        disabledDates: Array,
        companies: Array,
        permissionForUpdate: Boolean,
    },
    data() {
        return {
            eventInfo: {
                type: null,
                from: null,
                to: null,
                start_location: null,
                end_location: null,
                company_id: null,
                price: null,
                period: null,
                source: null,
            }
        }
    },
    mounted() {
        if (this.existingEvent) {
            this.eventInfo = this.existingEvent
        }
    },
    watch: {
        existingEvent: {
            handler(newVal) {
                if (newVal) {
                    this.eventInfo = { ...newVal };
                } else {
                    this.resetEventInfo();
                }
            },
            immediate: true
        }
    },
    methods: {
        resetEventInfo() {
            this.eventInfo = {
                type: null,
                from: null,
                to: null,
                start_location: null,
                end_location: null,
                company_id: null,
                price: null,
                period: null,
                source: null,
            };
        },
        formatDateToLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        checkDisabledDates(date) {
            const formattedDate1 = this.formatDateToLocal(date);
            return this.disabledDates.includes(formattedDate1);
        },
        closeModal() {
            for (let key in this.eventInfo) {
                if (this.eventInfo.hasOwnProperty(key)) {
                    this.eventInfo[key] = null;
                }
            }
            this.$refs.form.reset()
            $(`#${this.modalId}`).modal('hide');
        },
        async validate() {
            const isFormValid = await this.validateForm();
            if (!isFormValid) return;

            const isEventValid = this.isEventValid();
            if (!isEventValid) {
                this.$showValidationErrorMessage('Please choose another date. These days are unavailable');
                return;
            }

            await this.saveNewEvent();
        },
        async validateForm() {
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage();
                return false;
            }
            return true;
        },
        isEventValid() {
            const startDate = new Date(this.eventInfo.from);
            const endDate = new Date(this.eventInfo.to);

            const getDatesInRange = (start, end) => {
                const dates = [];
                let currentDate = new Date(start);

                while (currentDate <= end) {
                    dates.push(new Date(currentDate).toISOString().split("T")[0]);
                    currentDate.setDate(currentDate.getDate() + 1);
                }

                return dates;
            };

            const currentEventDates = getDatesInRange(startDate, endDate);

            const filteredDisabledDates = this.isUpdate
                ? this.disabledDates.filter(date => !currentEventDates.includes(date))
                : this.disabledDates;

            return !filteredDisabledDates.some(date => {
                const busyDate = new Date(date);
                return busyDate >= startDate && busyDate <= endDate;
            });
        },


        async saveNewEvent() {
           try {
              await EventsService.createNewEvent(this.artistId, this.eventInfo)
              this.$showSuccessMessage('New event was created')
               Object.keys(this.eventInfo).forEach(key => {
                   this.eventInfo[key] = null;
               });
               this.$emit('update-events')
               $(`#${this.modalId}`).modal('hide');

           } catch (e) {
               this.$showErrorMessage('The new event was not saved')
           }
        },
        async deleteEvent(id) {
            try {
                await EventsService.deleteEvent(id)
                this.$showSuccessMessage('The event has been deleted')
                $(`#${this.modalId}`).modal('hide');
                this.$emit('update-events')
            } catch (e) {
                this.$showErrorMessage('The event was not deleted')
            }
        }
    }
}

</script>


<style scoped>

</style>
